import { apolloClient } from '~/apollo-client';
import { SignNowDocumentGroupStatus } from '~/typings/signnow';
import {
  FETCH_SIGN_NOW_DOCUMENT_GROUP_FOR_ENROLLMENT,
  FETCH_SIGN_NOW_DOCUMENT_GROUP_STATUS,
} from './fetch-signnow-document-group.queries';

export interface SignNowDocumentGroup {
  id: number;
  status: SignNowDocumentGroupStatus;
  signingUrl?: string | null;
  userId: number;
  inviteExpiresAt?: string | null;
  envelopeIds: number[];
}

interface FetchSignNowDocumentGroupByPlanParams {
  planId: number;
}

interface FetchSignNowDocumentGroupStatusParams {
  id: number;
}

export const fetchSignNowDocumentGroupByPlan = async (
  params: FetchSignNowDocumentGroupByPlanParams,
): Promise<SignNowDocumentGroup | null> => {
  const { data } = await apolloClient.query<
    {
      signNowDocumentGroupByPlan: {
        id: number;
        status: string;
        signingUrl?: string | null;
        userId: number;
        inviteExpiresAt?: string | null;
        envelopeIds: number[];
      } | null;
    },
    { planId: number }
  >({
    fetchPolicy: 'no-cache',
    query: FETCH_SIGN_NOW_DOCUMENT_GROUP_FOR_ENROLLMENT,
    variables: { planId: params.planId },
  });

  const group = data?.signNowDocumentGroupByPlan;
  if (!group) return null;

  return {
    ...group,
    status: group.status as SignNowDocumentGroupStatus,
  };
};

export const fetchSignNowDocumentGroupStatus = async (
  params: FetchSignNowDocumentGroupStatusParams,
): Promise<SignNowDocumentGroup> => {
  const { data } = await apolloClient.mutate<
    {
      fetchSignNowDocumentGroupStatus: {
        id: number;
        status: string;
        signingUrl?: string | null;
        userId: number;
        inviteExpiresAt?: string | null;
        envelopeIds: number[];
      };
    },
    { id: number }
  >({
    mutation: FETCH_SIGN_NOW_DOCUMENT_GROUP_STATUS,
    variables: { id: params.id },
  });

  const group = data?.fetchSignNowDocumentGroupStatus;
  if (!group) {
    throw new Error('Failed to fetch SignNow document group status');
  }
  return {
    ...group,
    status: group.status as SignNowDocumentGroupStatus,
  };
};
